import { BulkImportUsersDialogCtrl } from '../controllers/BulkImportUsersDialogCtrl';
import { Module } from '../Module';
import { ModalService, ModalSize } from './ModalService';
import { ServerService } from './ServerService';

export class BulkImportUsersAction {

  public static $inject = ['ModalService', 'ServerService'];

  constructor(private modal: ModalService, private server: ServerService) { }

  public showBulkImportSiteUsersDialog(dialogScope: ng.IScope): ng.IPromise<any> {
    return this.showBulkImportUsersDialog(dialogScope, BulkImportUsersDialogCtrl.Method.ImportUsersFromCsv, this.server.isSiteSamlEnabled());
  }

  public showBulkImportServerUsersDialog(dialogScope: ng.IScope): ng.IPromise<any> {
    return this.showBulkImportUsersDialog(dialogScope, BulkImportUsersDialogCtrl.Method.ImportServerUsersFromCsv, false);
  }

  private showBulkImportUsersDialog(dialogScope: ng.IScope, method: string, showAuthSettingSelector: boolean): ng.IPromise<any> {
    const dialogInstance = this.modal.open({
      scope: dialogScope,
      templateUrl: 'bulkImportUsersDialog.html',
      closeX: false,
      size: ModalSize.fitToContent,
      controller: BulkImportUsersDialogCtrl,
      resolve: {
        method: () => method, // BulkImportUsersDialogCtrl.Method
        showAuthSettingSelector: () => showAuthSettingSelector
      }
    });

    return dialogInstance.result;
  }

}

Module.instance().service('BulkImportUsersAction', BulkImportUsersAction);
